( function ( $ ) {

	$('.indy-block-accordion-header').on( "click", function(e) {
		const wrapper = $(this).parent();
		const content = wrapper.find('.indy-block-accordion-content');
		const duration = 300;

		content.stop(); // stop all prior animations

		// if wrapper is already open -> close only after animation has played
		if (wrapper.attr('open')) {
			e.preventDefault();

			content.slideUp(duration);

			setTimeout(function () {
				wrapper.removeAttr('open');
			}, duration);
		} else {
			// as soon as open state is toggled (contents now visible) -> slideDown animation
			wrapper.one("toggle", function() {
				content.slideDown(duration);
			});
		}
	});

} )( jQuery );